var _g, _rect, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 71,
    viewBox: "0 0 48 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5580_1453)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 63,
    rx: 10,
    transform: "matrix(-1 0 0 1 44 2)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5580_1453",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 26,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 26,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5580_1453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7667 40.0667C20.6 39.9 20.5167 39.7028 20.5167 39.475C20.5167 39.2472 20.6 39.05 20.7667 38.8834L25.65 34L20.75 29.1C20.5945 28.9445 20.5167 28.75 20.5167 28.5167C20.5167 28.2834 20.6 28.0834 20.7667 27.9167C20.9334 27.75 21.1306 27.6667 21.3584 27.6667C21.5861 27.6667 21.7834 27.75 21.95 27.9167L27.55 33.5334C27.6167 33.6 27.6639 33.6722 27.6917 33.75C27.7195 33.8278 27.7334 33.9111 27.7334 34C27.7334 34.0889 27.7195 34.1722 27.6917 34.25C27.6639 34.3278 27.6167 34.4 27.55 34.4667L21.9334 40.0834C21.7778 40.2389 21.5861 40.3167 21.3584 40.3167C21.1306 40.3167 20.9334 40.2334 20.7667 40.0667Z",
    fill: "#434343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5580_1453",
    x: 0,
    y: 0,
    width: 48,
    height: 71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5580_1453"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5580_1453",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.c0f0976391888aeabcd4cf7e0cabbcb6.svg";
export { ForwardRef as ReactComponent };